//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'App',
    watch:{   //监听路由变化
        $route( to , from ){ 
            if (to.name == 'EnrollType' && from.name == 'GqpxView') {
                this.$router.push({name: 'Index'})
            }
            window.scrollTo(0,0)
        }
    },
    created () {
    }
}



// WEBPACK FOOTER //
// ./src/App.vue